import { Link } from 'react-router-dom';
import styled from 'styled-components';

const DropdownBoxTextContainer = styled.div`
  display: flex;
  margin: 0;
  padding: 0;
  font-size: 0.8;
  height: 100%;
  flex-direction: column;
  justify-content: stretch;
`;

const DropdownBoxText = styled(Link)`
  text-decoration: none;
  margin: 0;
  padding: 0;
  font-size: 0.8;
  color: #003876;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;

  &:hover {
    background-color: #d5d7da;
    border-radius: 6px;
    cursor: pointer;
  }
`;

export { DropdownBoxText, DropdownBoxTextContainer };
